import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Card, Row, Col, Layout, Button, Table } from 'antd';
import TickerSearch from "../../Components/TickerSearch/TickerSearch";
import DateRange from "../../Components/DateRange"; // Import DateRange
import { useRankFeatures } from '../../Hooks/useLargeDataAnalyticsApi';
import { useEnsureTickersLoaded } from "../../Hooks/useEnsureTickersLoaded";
import { transformMatrixToHeatmap } from "../../lib/matrixTools";
import NivoHeatChart from "../../charts/nivo/NivoHeatChart";
import { transformDataForNivoHeatMap } from "../../charts/nivo/NivoHeatChart";
import TickerChip from "../../Components/TickerChip";
import FeatureRankTable from "./FeatureRankTable";
const { Content } = Layout;




const RankCard = ({ results }) => {
  console.log(results);
  const labels = results?.info_results?.map(x => x.label);
  const { tickers } = useEnsureTickersLoaded(labels || ['spy']);
  const corrMatrix = results?.corr_matrix;
  const transformedData = transformDataForNivoHeatMap(transformMatrixToHeatmap(corrMatrix, labels));

  return (
    <Card>
      <Row wrap={true}>
        {labels?.map((label, index) => (
            <TickerChip key={index} ticker={tickers.find(x=>x.symbol===label)} />
        ))}
      </Row>
      <Row>
        <Col flex={'0 0 300px'}>
          <div style={{ height: '300px', width: '100%' }}>
            <NivoHeatChart data={transformedData} keys={labels} labelSize={11} showUpperAxis={false} padLeft={50} />
          </div>
        </Col>
        <FeatureRankTable featureRankings={results.feature_rankings} infoResults={results.info_results} tickers={tickers} />
      </Row>
    </Card>
  );
};

const RankFeatures = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { rankFeatures, fetchRankFeatures } = useRankFeatures();
  const [selectedTickers, setSelectedTickers] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const symbolsParam = searchParams.get('symbols');
    if (symbolsParam) {
      const symbols = symbolsParam.split(',').filter(Boolean);
      fetchRankFeatures({ symbols, start_date: startDate, end_date: endDate });
    }
  }, [searchParams, fetchRankFeatures, startDate, endDate]);

  const handleNewFetch = () => {
    if (selectedTickers.length > 0) {
      fetchRankFeatures({ symbols: selectedTickers.map(t => t.symbol), start_date: startDate, end_date: endDate });
    }
  };

  const handleTickersSubmit = (newTickers) => {
    const uniqueNewTickers = newTickers.filter(newTicker => !selectedTickers.some(ticker => ticker.symbol === newTicker.symbol));
    setSelectedTickers(prevTickers => prevTickers.concat(uniqueNewTickers));
    setShowSearch(false);
  };

  const handleAddETFsClick = () => {
    setShowSearch(true); // Open the search popup
  };

  const handleDateRangeChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <Layout>
      <Content style={{ padding: '50px' }}>
        <Button type="primary" onClick={handleNewFetch} style={{ marginBottom: '20px' }}>
          Fetch New Rank Features
        </Button>
        <Button type="primary" onClick={handleAddETFsClick} style={{ marginBottom: '20px', marginLeft: '20px' }}>
          Add ETFs
        </Button>
        {showSearch && (
          <TickerSearch
            onTickersSubmit={handleTickersSubmit}
            closeSearch={() => { setShowSearch(false); }}
            types={['etf']}
          />
        )}
        <DateRange
          onDateRangeChange={handleDateRangeChange}
          startDate={startDate}
          endDate={endDate}
          minDate={'2015-01-01'}
          maxDate={'2024-07-11'}
          dateFormat={'YYYY-MM-DD'}
        />
        <Row gutter={[16, 16]}>
          {rankFeatures && rankFeatures.map((feature, index) => (
            <Col span={24} key={index}>
              <div>{index}</div>
              <RankCard results={feature} />
            </Col>
          ))}
        </Row>
      </Content>
    </Layout>
  );
};

export default RankFeatures;
